import type { AppConfig, BillingMode } from "@/api/types";

export function isExperimentalBilling(mode: BillingMode): boolean {
  return mode === "bypass" || mode === "shadow";
}

export function canShowCommercialUi(
  config: Pick<AppConfig, "billing_mode" | "commercial_entitled">,
  userEntitled = config.commercial_entitled,
): boolean {
  return config.billing_mode === "enforced" && userEntitled;
}
